import { captureException, configureScope, init } from '@sentry/browser';
import { reactRouterV5Instrumentation } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { History } from 'history';
import Store from 'repatch';

import State from '../core/State';

class ErrorReporter {
  private store: Store<State>;

  constructor({
    store,
    dsn,
    environment,
    release,
    history,
  }: {
    store: Store<State>;
    dsn: string;
    environment: string;
    release: string;
    history: History;
  }) {
    this.store = store;
    init({
      dsn: dsn,
      environment: environment,
      release,
      ignoreErrors: ['ResizeObserver loop limit exceeded'],
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: reactRouterV5Instrumentation(history),
          beforeNavigate: (context) => {
            return {
              ...context,
              name: location.pathname.replace(/PJ.*?(?=\/)/, '<ProjectID>').replace(/CR.*?(?=\/|$)/, '<CreationID>'),
            };
          },
        }),
      ],
      tracesSampleRate: 0.3,
    });
  }

  public reportError = (err: Error) => {
    const state: State = this.store.getState();
    configureScope((scope) => {
      if (state.authentication.signedInUser) {
        scope.setUser({
          id: state.authentication.signedInUser.id,
          username: state.authentication.signedInUser.name,
          email: state.authentication.signedInUser.email ? state.authentication.signedInUser.email : undefined,
        });
      }
      scope.setExtras(state);
    });
    captureException(err);
    window.newrelic.noticeError(err);
  };
}

export default ErrorReporter;
